export default __webpack_public_path__ + "static/media/m_ptm_bg_2.970d5662.png";